/* eslint-disable no-unused-vars */
import { create } from 'zustand'

interface SoftLockDialogState {
  isSoftLockDialogOpen: boolean
  hasSoftLock: boolean
  targetUrl: string | null
  setHasSoftLock: (value: boolean) => void
  setOpenDialogSoftLock: (isOpen: boolean, targetUrl?: string) => void
}
export const useSoftLockDialogStore = create<SoftLockDialogState>((set) => ({
  isSoftLockDialogOpen: false,
  hasSoftLock: false,
  targetUrl: null,
  setHasSoftLock: (value: boolean) => set({ hasSoftLock: value }),
  setOpenDialogSoftLock: (value: boolean, targetUrl = '') => set({ isSoftLockDialogOpen: value, targetUrl }),
}))